/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Switch from "../ingka/Switch"
import Select from "./Select";
import Input from "../ingka/Input";
import Text from "../ingka/Text";
import { useSessionStore } from "../../store/sessionStore";
import { useSectionTypes } from "../../hooks/use-section-types";
import { useSectionSubtypes } from "../../hooks/use-section-subtypes";
import { useSectionUpdate } from "../../hooks/use-section-update";
import usePointsConverter from "../../hooks/usePointsConverter";
import useCanvasSizing from "../../hooks/useCanvasSizing";

export default function AddPolygon({type, polygon, mode, save, disabledSave, points, canvasSize, mapId, parentId, updatePolygonState, fatherValue}) {
  const [t] = useTranslation("global")
  const [active, setActive] = useState(1)
  const [polygonType, setPolygonType] = useState(null)
  const [polygonSubType, setPolygonSubType] = useState(null)
  const { user, myStore } = useSessionStore()
  const [motionGoal, setMotionGoal] = useState(10)
  const [otherHfb, setOtherHfb] = useState(null)
  const [otherHfbOptions, setOtherHfbOptions] = useState(null)
  const [differentVersion, setDifferentVersion] = useState(false)
  const [alertMessage, setAlertMessage] = useState([])
  const { sectionTypesOptions, isLoadingSectionTypes } = useSectionTypes(mode)
  const { sectionSubtypesOptions, getSubtypesOptions } = useSectionSubtypes()
  const { sectionUpdate } = useSectionUpdate()
  const { pixelToPercent } = usePointsConverter()
  const { calculatePolygonSize } = useCanvasSizing()

  useEffect(()=>{
   if(type === "PUT"){
        setActive(polygon.active)
        setMotionGoal(polygon.motionGoal)
      }
   
    //Review if points is edited
    if(polygon.points !== undefined){
      if(JSON.stringify(points) !== JSON.stringify(polygon.points)){
        setDifferentVersion(true)
      }
    }
  },[])

  useEffect(()=>{
   if(sectionTypesOptions.length > 0 && type === "PUT" && polygon.type){
      setPolygonType(sectionTypesOptions.find(el => el.value === polygon.type.value))
    }
  },[sectionTypesOptions])

  useEffect(() => {
    //Review if this polygon has motions for new version
    if(differentVersion){
      if(polygon.level === 1 ){ //is section level
        setAlertMessage([
          t("map.msgChangeSection"),
          ...(polygon.accumulationMovements !== 0 ? [t("map.msgCreateNewVersion")]: [])
        ])
      }else { //is subsection level
        setAlertMessage([
          ...(polygon.accumulationMovements !== 0 ? [t("map.msgCreateNewVersion")]: [])
        ])
      }
    }
    
  },[differentVersion])

  useEffect(() => {
    if(polygonType && polygonType.hasSubOption){
      getSubtypesOptions(polygonType, fatherValue);
    }

    if(polygonType && polygonType.value === "4" && mode === "subsection"){ // is other HFB in subsection
      setOtherHfb(null)
      getSubtypesOptions({nameSubOption:"HFBs", value: "1"}, fatherValue);
    }
  },[polygonType])

  useEffect(() => {
    if(sectionSubtypesOptions.length > 0){
      if(type === "PUT" && polygon.subType){
        setPolygonSubType(sectionSubtypesOptions.find(el => el.value === polygon.subType.value))
      }
      if(polygonType && polygonType.value === "4" && mode === "subsection" && !otherHfb){ // is other HFB in subsection
        setOtherHfbOptions(sectionSubtypesOptions)
      }
    }
  },[sectionSubtypesOptions])

  useEffect(() => {
    setPolygonSubType(null)
    if(otherHfb){
      getSubtypesOptions({nameSubOption:"PAs", value: "1"}, otherHfb.value);
    }
  },[otherHfb])

  useEffect(() =>{
    if((polygonType && polygonSubType) || (polygonType && !polygonType.hasSubOption)){
      disabledSave(false)
    }
  },[active,polygonType,polygonSubType])

  useEffect(() => {
    if(save){
      
      const polygonSize = calculatePolygonSize(points, canvasSize.w, canvasSize.h)
      const pointsCopy = JSON.parse(JSON.stringify(points));
      const pointsPercent = JSON.stringify(pixelToPercent(pointsCopy, canvasSize.w, canvasSize.h))

      const data = {
        width: polygonSize.w,
        height: polygonSize.h,
        storeId: myStore.id,
        point: pointsPercent,
        level: mode === "section" ? 1 : 2,
        map_id: mapId,
        parentSection_id: mode === "section" ? null : parentId,
        active: active ? 1 : 0,
        userId: user,
        typeId: polygonType.value,
        subTypeId: polygonSubType ? polygonSubType.value : null,
        motionGoal: motionGoal,
        name: polygonType.label + (polygonSubType ? " - "+polygonSubType.label : ''),
        ...(differentVersion && polygon.accumulationMovements !== 0 ? {version: {
            width:polygon.width,
            height: polygon.height,
            point: polygon.point,
            name: polygon.name,
            date: polygon.modificationDate ? polygon.modificationDate : polygon.creationDate
        }} : {})
      }
      sectionUpdate({type, data, polygon, successMsg: t("map.success"+type+mode)}, {
        onSuccess: (response) => {
          updatePolygonState(response)
        }
      })
      
    }
  },[save])

  return (
    <>
      <div style={{minHeight: 300}}>
        {type === "PUT" &&
          <div className="col-12" style={{display: "flex",justifyContent: "end"}}>
            <Switch
              props={{
                checked: active,
                onChange: (e)=> setActive(e.target.checked)}
            } 
            />
          </div>
        }
        <Select 
          formField={{className:"col-12"}}
          label={t("map.polygonType")}
          defaultValue={polygonType}
          value={polygonType}
          onChange={(val) => {
            setPolygonType(val)
            setPolygonSubType(null)
          }}
          isClearable={false}
          isSearchable={false}
          id="type"
          name="type"
          options={sectionTypesOptions}
          isLoading={isLoadingSectionTypes}
        />

        {otherHfbOptions && polygonType.value === "4" && mode === "subsection" &&
          <Select 
            formField={{className:"col-12"}}
            label={t("map.otherHfb")}
            defaultValue={otherHfb}
            value={otherHfb}
            onChange={(val) => setOtherHfb(val)}
            isClearable={false}
            isSearchable={true}
            id="otherHfb"
            name="otherHfb"
            options={otherHfbOptions}
          />
        }

        {polygonType && polygonType.hasSubOption &&
          <Select 
            formField={{className:"col-12"}}
            label={t("map.polygonSubType")}
            value={polygonSubType}
            defaultValue={polygonSubType}
            onChange={(val) => setPolygonSubType(val)}
            isClearable={false}
            isSearchable={true}
            id="subtype"
            name="subtype"
            options={sectionSubtypesOptions}
          />
        }

        <Input 
          formField={{
            className: "col-12"
          }}
          input={{
            label: t("map.motionGoal"+mode),
            type:"number",
            value: motionGoal,
            onChange: e => setMotionGoal(e.target.value)
          }}
        />
        {differentVersion &&
          alertMessage.map( (msg, index) => (
            <Text key={index} tagName="p" headingSize="s" className="text-red">{msg}</Text>
          ))
        }
      </div>
    </>
  )
}
